export const GET_AUDIENCES_M = (id: string, preview: boolean) => `
query {
  audience (id: "${id}", preview: ${preview}){
    audianceId
  }
}
`;
